import { TableCell } from '@material-ui/core';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import React from 'react';
export const DateCell = props => {
  return /*#__PURE__*/React.createElement(TableCell, {
    style: props.virtual ? {
      height: '57px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0
    } : {},
    component: props.virtual ? 'div' : 'td'
  }, props.date && formatDistanceToNow(new Date(props.date), {
    locale: props.locale,
    addSuffix: true
  }));
};
//# sourceMappingURL=DateCell.js.map